export var Theme;
(function (Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
})(Theme || (Theme = {}));
export var ThemeLogos;
(function (ThemeLogos) {
    ThemeLogos["DARK"] = "\uD83C\uDF1A";
    ThemeLogos["LIGHT"] = "\uD83C\uDF1E";
})(ThemeLogos || (ThemeLogos = {}));
